import React from "react";
import { type FreefieldInputProps } from "../models";
import BaseReactSelectDropdown from "components/dropdowns/reactselect/BaseReactSelectDropdown";

interface Props extends FreefieldInputProps {
  dropdownOptions: string[]
}

const FreefieldDropdown = (props: Props) => {
  const [selected, setSelected] = React.useState<string | null>(props.initialValue);

  // ReactSelectDropdown only works with object arrays
  const options = [
    { value: RESX.Buttons.btnMakeSelection },
    ...props.dropdownOptions.map(option => ({
      value: option
    }))
  ];

  const selectedValue = selected == null ? null : { value: selected };

  const onChange = (selectedOption: { value: string }) => {
    if (selectedOption.value === RESX.Buttons.btnMakeSelection) {
      setSelected(null);
      props.onChange(null);
    } else {
      setSelected(selectedOption.value);
      props.onChange(selectedOption.value);
    }
  };

  return <BaseReactSelectDropdown
    excludeKeys={[]}
    getLabel={o => o.value}
    getValue={o => o.value}
    value={selectedValue}
    onChange={onChange}
    options={options}
    config={{
      isSearchable: false,
      shouldRenderSelectedValue: true,
      placeholder: RESX.Buttons.btnMakeSelection
    }}
  />;
};

export default FreefieldDropdown;